/**
* @description: 歌曲点播排行报表
* @author: wgt
*/
<template>
    <div class="or-song-month-report">
        <div class="list">
            <p class="tip">注：报表仅显示门店近3个月内点播排行数据</p>
            <el-form :inline="true" :model="list_form" size="small">
                <el-form-item label="门店">
                    <el-select v-model="list_form.shop_id" placeholder="请选择门店">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </el-form-item>
                <el-form-item label="月份">
                    <el-select v-model="list_form.month" placeholder="请选择月份">
                        <el-option v-for="item in month_list" :key="item" :label="item + '月'" :value="item" />
                    </el-select>
                </el-form-item>
                <el-form-item label="歌手">
                    <el-input v-model="list_form.player" placeholder="请输入歌手名称" />
                </el-form-item>
                <el-form-item label="歌名">
                    <el-input v-model="list_form.title" placeholder="请输入歌曲名称" />
                </el-form-item>
                <el-form-item label="歌曲编号">
                    <el-input v-model="list_form.song_code" placeholder="请输入歌曲编号" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getList">查询</el-button>
                    <el-button @click="exportExcel">导出</el-button>
                </el-form-item>
            </el-form>
            <div class="table">
                <el-table :data="table_data" style="width: 100%">
                    <el-table-column prop="listorder" label="排序" />
                    <el-table-column prop="player" label="歌星" />
                    <el-table-column prop="title" label="歌曲" />
                    <el-table-column prop="song_code" label="歌曲编号" />
                </el-table>
                    <el-pagination
                        :current-page="page"
                        layout="prev, pager, next, jumper, total"
                        :page-size="GLOBAL.PAGESIZE"
                        :total="total"
                        @current-change="getList"
                    />
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import Global from '../../../components/global.vue';

export default {
    name: 'or_song_month_report',
    data() {
        return {
            list_form: {
                shop_id: "",
                month: "",
                player: "",
                title: "",
                song_code: "",
            },
            shop_list: [],
            month_list: [],
            table_data: [],
            total: 0,
            page: 1,
            page_size: 10,
            loading: false,
        }
    },
    mounted() {
        this.getShop(() => {
            this.list_form.shop_id = this.shop_list[0]?.id || "";
            this.month_list = this.getRecentMonths();
            this.list_form.month = this.month_list[0];
            this.getList();
        });
    },
    methods: {
        // 初始化门店输入框
        getShop: function (resolve) {
            const _this = this;

            Vue.axios
                .post("PublicData/api_getShopListByPurview", {
                    header: Vue.request_header,
                    request: {
                        version: Vue.version,
                        param: {},
                    },
                    comment: "",
                })
                .then((res) => {
                    if (res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve();
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch((err) => {
                    layer.msg("出错啦");
                });
        },
        // 初始化月份输入框
        getRecentMonths() {
            const currentDate = new Date(); // 获取当前日期对象
            const currentMonth = currentDate.getMonth() + 1; // 当前月份（1-12）
            const result = [];

            // 生成前三个月的月份值（不包含当前月）
            for (let i = 0; i < 3; i++) {
                // 计算目标月份（当前月向前倒推，从上个月开始）
                let targetMonth = currentMonth - i - 1;
                // 处理跨年：月份值小于1时调整到上一年
                if (targetMonth < 1) {
                    targetMonth += 12; // 从12月开始倒推
                }
                result.unshift(targetMonth); // 将月份插入数组开头（保证顺序）
            }
            return result.reverse(); // 返回反转后的数组，如 [6,5,4] 或 [1,12,11]
        },
        getList() {
            const _this = this;
            _this.loading = true;
            Vue.axios.post("Report/getSongsMonthCount", {
                header: Vue.request_header,
                request: {
                    version: Vue.version,
                    param: {
                        shop_id: _this.list_form.shop_id,
                        month: _this.list_form.month,
                        player: _this.list_form.player,
                        title: _this.list_form.title,
                        song_code: _this.list_form.song_code,
                        page: _this.page,
                        page_size: _this.GLOBAL.PAGESIZE,
                    },
                },
            }).then(res => {
                _this.loading = false;
                console.log('res', res.data);

                if (res.data.response.result_code == "true") {
                    _this.table_data = res.data.response.result.data;
                    _this.total = res.data.response.result.count;
                } else {
                    Vue.timeoutfun(res.data.response.result_status, _this);
                    layer.msg(res.data.response.error_msg);
                }
            }).catch(err => {
                _this.loading = false;
                layer.msg("出错啦");
            });
        },
        exportExcel() {
            window.location.href =
				Vue.ctUrl +
				"Report/exportSongsMonthCount" +
				"?shop_id=" +
				this.list_form.shop_id +
				"&month=" +
				this.list_form.month +
				"&player=" +
				this.list_form.player +
				"&title=" +
				this.list_form.title +
				"&song_code=" +
				this.list_form.song_code;
			layer.msg("导出成功！");
        }
    }
}
</script>

<style lang="less" scoped>
.tip {
    color: #f00;
    font-size: 16px;
    margin-bottom: 10px;
}
</style>